import {
  GET_ALL_ADVERTISEMENTS_ERROR,
  GET_ALL_ADVERTISEMENTS_START,
  GET_ALL_ADVERTISEMENTS_SUCCESS,
} from 'constants/action-types/communication/getAllAdvertisment';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADVERTISEMENTS_START:
      return {
        ...state,
        allAdvertisements: {
          ...state.allAdvertisements,
          loading: true,
          error: null,
          data: [],
        },
      };
    case GET_ALL_ADVERTISEMENTS_ERROR:
      return {
        ...state,
        allAdvertisements: {
          ...state.allAdvertisements,
          error: payload,
          loading: false,
        },
      };
    case GET_ALL_ADVERTISEMENTS_SUCCESS:
      return {
        ...state,
        allAdvertisements: {
          ...state.allAdvertisements,
          data: payload.data,
          loading: false,
        },
      };
    default:
      return null;
  }
};
